
interface ITodoStats {
  total: number;
  active: number;
  completed: number;
}

const TodoStats = ({ total, active, completed }: ITodoStats) => {
  return (
    <div className="todo-stats">
      <div className="stat-item">
        <span className="stat-number">{total}</span>
        <span className="stat-label">Total</span>
      </div>
      <div className="stat-item">
        <span className="stat-number active">{active}</span>
        <span className="stat-label">Active</span>
      </div>
      <div className="stat-item">
        <span className="stat-number completed">{completed}</span>
        <span className="stat-label">Completed</span>
      </div>
    </div>
  );
};

export default TodoStats;
